module.exports = "/images/48a8e39a19e2eca1693c869458837fb5.png";